import React from 'react';

import { Skeleton, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useContainer } from 'unstated-next';

import IntegrationsHeader from './IntegrationsHeader';
import IntegrationTableRow from './IntegrationTableRow';
import AdminAuthContainer from '../../AdminAuthContainer';
import AdminIntegrationsContainer from '../../AdminIntegrationsContainer';

const StyledTable = styled(Table)`
    margin-top: 12px;
`;

const StyledSkelton = styled(Skeleton)`
    height: 70px;
`;

const IntegrationList: React.FC = () => {
    const { t } = useTranslation('admin_settings');
    const { isLoading } = useContainer(AdminAuthContainer);
    const { integrations, integrationsFetchStatus } = useContainer(AdminIntegrationsContainer);

    const TableSkeletons = () => (
        <>
            <StyledSkelton />
            <StyledSkelton />
            <StyledSkelton />
            <StyledSkelton />
        </>
    );

    const renderTable = () => {
        if (integrationsFetchStatus && !isLoading) {
            return (
                <StyledTable>
                    <TableHead>
                        <TableRow>
                            <TableCell>{t('title')}</TableCell>
                            <TableCell>{t('lti-type')}</TableCell>
                            <TableCell>{t('lms-name')}</TableCell>
                            <TableCell>{t('date-modified')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {integrations.map((integration, index) => (
                            <IntegrationTableRow data={integration} key={index} />
                        ))}
                    </TableBody>
                </StyledTable>
            );
        }
        return <TableSkeletons />;
    };
    return (
        <>
            <IntegrationsHeader />
            {renderTable()}
        </>
    );
};

export default IntegrationList;
